/**
 * Format ISO date string to user-friendly format
 * @param isoString - ISO date string (e.g., "2024-01-15T10:30:00.000Z")
 * @returns Formatted date string (e.g., "Jan 15, 2024, 10:30 AM")
 */
export const formatLastLoginTime = (isoString: string): string => {
  try {
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Unknown time';
  }
};

/**
 * Check if a date string is valid
 * @param dateString - Date string to validate
 * @returns boolean indicating if the date is valid
 */
export const isValidDate = (dateString: string | null): boolean => {
  if (!dateString) return false;
  const date = new Date(dateString);
  return !isNaN(date.getTime());
};
